import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { Spinner } from "@/components/General/Spinner/spinner.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { FixedField } from "../../../FormFields/FixedField/fixedField.component";
import { TextField } from "../../../FormFields/TextField/Textfield.component";
import { useAddressFormBlockContext } from "../addressFormBlock.context";
import { CustomerDeliveryAddressFormValues } from "../addressFormBlock.schema";
import { useDeliveryHook } from "../helpers/useDelivery.hook";
import { DeliveryAddressPartial } from "../partials/deliveryAddress";

const DeliveryCustomerAddress = () => {
    const { t } = useGranite();
    const { loading } = useDeliveryHook();

    const { addPrefix } = useAddressFormBlockContext();

    if (loading) {
        return <Spinner />;
    }

    return (
        <>
            <Row>
                <Col md={12}>
                    <TextField<CustomerDeliveryAddressFormValues>
                        test={`customerAddress-input-${addPrefix(
                            "addressing"
                        )}`}
                        name={"delivery.addressing"}
                        required={false}
                        label={t("general.form.address.addressing.label")}
                        placeholder={t(
                            "general.form.address.addressing.placeholder"
                        )}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <TextField<CustomerDeliveryAddressFormValues>
                        test={`customerAddress-input-${addPrefix("firstName")}`}
                        name={"delivery.firstName"}
                        label={t("general.form.address.firstName.label")}
                        required
                        placeholder={t(
                            "general.form.address.firstname.placeholder"
                        )}
                        autoComplete={"given-name"}
                    />
                </Col>
                <Col md={6}>
                    <TextField<CustomerDeliveryAddressFormValues>
                        test={`customerAddress-input-${addPrefix("lastName")}`}
                        name={"delivery.lastName"}
                        label={t("general.form.address.lastName.label")}
                        required
                        placeholder={t(
                            "general.form.address.lastName.placeholder"
                        )}
                        autoComplete={"family-name"}
                    />
                </Col>
            </Row>
            <DeliveryAddressPartial />
            <Row>
                <Col md={12}>
                    <FixedField<CustomerDeliveryAddressFormValues>
                        name={"delivery.country"}
                        label={t("general.form.address.country.label")}
                        required
                        displayedValue={t("general.country.be")}
                    />
                </Col>
            </Row>
        </>
    );
};

export { DeliveryCustomerAddress };
